const Footer = () => {
  return (
    <footer className="bg-slate-900 border-t border-slate-800 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto text-center">
        <p className="text-gray-400 text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>
          Copyright Locusup © All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
